<main class="main-dashboard">
  <article class="main-canvas">
    <section class="canvas-container">
      <section class="dashboard-items">
        <form [formGroup] = "attendanceDetailsForm">
          <div class="canvas-item">
            <div class="canvas-header row justify-content-between align-items-center">
              <div class="title col-sm-6">
                <h3>Regularizations Approval</h3>
              </div>
            </div>
            <div class="row">
              <div class="canvas-header row justify-content-between align-items-center">
                <div class="row p-0">
                  <div class="col-sm-12 p-0">
                    <div class="canvas-data px-0">
                      <div class="row m-0">
                        <div class="col-sm-3 col-md-6 col-lg-3 col-xl-3 mb-2">                          
                          <div class="dropdown mx-2">
                            <button class="btn btn-small btn-grey dropdown-toggle"
                              type="button" id="excel-columns" data-toggle="dropdown" >
                                Regularizations Approval
                            </button>
                            <div class="dropdown-menu">
                              <a class="dropdown-item" (click)="openLeaveApproval()">Leave Approval</a>
                              <a class="dropdown-item" (click)="openTimesheetApproval()">Timesheet Approval</a>
                              <a class="dropdown-item" (click)="openCompOffApproval()">Comp-0ff Approval</a>
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-3 col-md-6 col-lg-3 col-xl-3 mb-2">
                          <div class="input">
                            <div class="input-item">
                              <input type="date" formControlName="startDate" />
                              <label class="floating-label-special">From</label>
                              <i class="ri-calendar-line"></i>
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-3 col-md-6 col-lg-3 col-xl-3 mb-2">
                          <div class="input">
                            <div class="input-item">
                              <input type="date" formControlName="endDate"/>
                              <label class="floating-label-special">To</label>
                              <i class="ri-calendar-line"></i>
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-3 col-md-6 col-lg-3 col-xl-3 mb-2">
                          <button type="button" class="btn" (click)="getHrLookup()">
                            <div>Submit</div>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <ag-grid-angular style="margin: 15px; height: 500px"
                class="ag-theme-material"
                (gridReady)="onGridReady($event)"
                [rowData]="rowData"
                [columnDefs]="columnDefs"
                pagination="true"
                [defaultColDef]="defaultColDef"
                [suppressRowClickSelection]="true"
                [rowSelection]="rowSelection"
                (selectionChanged)="onSelectionChanged($event)"
                paginationPageSize="10">
              </ag-grid-angular>
            </div>
          </div>
        </form>
      </section>
    </section>
  </article>
</main>